import React from 'react';
import {inject, observer} from 'mobx-react';
import {observe} from 'mobx'
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import PrivateRoutes from './private';
import PublicRotes from './public';
import HttpClient from 'services/HttpClient';

const SUBSCRIPTIONS = '/api/v1/subscriptions';
const TOPICS_REQUEST = '/api/v1/tutorials/';

@withRouter
@inject('userStore')
@inject('examPrepHeaderStore')
@inject('preloaderStore')
@observer
export default class Routing extends React.Component {
  state = {routers: <PublicRotes/>};

  componentWillMount() {
    this.props.userStore.initUser();
    this.listener = observe(this.props.userStore, 'user', () => {
      this.initUser();
    });
    this.initUser();
  }

  checkSubscription = () => {
    this.props.preloaderStore.activate();

    if (this.props.userStore.user && !this.props.userStore.isAdmin()) {
      new HttpClient().get(SUBSCRIPTIONS).then(data => {
        if(data.body.data.transctions) {
          this.setState({payments: data.body.data.transctions, active: data.body.data.active})
          const hasActive = data.body.data.transctions.filter(transaction => transaction.status === 'success' && moment().isSameOrBefore(moment(transaction.end_date, 'DD/MM/YYYY')))[0];

          if (hasActive) {
            new HttpClient().get(`${TOPICS_REQUEST}1`).then(data => {
              const topic = data.body.data.tutorial;

              this.props.examPrepHeaderStore.setTopic(topic);
              this.props.userStore.setIsSubscribed(!!hasActive);
              this.props.history.push('/exam-prep/topic/1');
              this.props.preloaderStore.disable();
            }).catch((e) => {
              this.props.preloaderStore.disable();

              if(e.status === 403) {
                this.props.history.push('/settings/payments');
                this.props.userStore.setIsSubscribed(false);
              } else {
                this.props.userStore.setIsSubscribed(!!hasActive);
              }
            });
          } else {
            this.props.preloaderStore.disable();
          }
        }
      }).catch(() => {
        this.props.preloaderStore.disable();
      });
    } else {
      this.props.preloaderStore.disable();
    }
  };

  initUser = () => {
    const {userStore} = this.props;

    this.checkSubscription();

    let routers = userStore.user ? <PrivateRoutes /> : <PublicRotes />;

    this.setState({routers});
  };

  componentWillUnmount(){
    this.listener();
  }

  render() {
    return(
      <div className="wrapper">
        {this.state.routers}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.js